/**
 * Brand theme context (TMMAPP-0035). `brandTheme` is the active resolved theme — the tenant's
 * (fetched or cached) or the built-in default; `setBrandTheme` swaps it in place (the MUI theme
 * re-renders, no reload). Outside a provider it reads the built-in default.
 */
import { createContext, useContext } from 'react';
import type { BrandTheme } from '@/theme/brandTheme';
import { PLATFORM_DEFAULT_THEME } from '@/theme/platformDefaultTheme';

export interface BrandThemeContextValue {
  brandTheme: BrandTheme;
  setBrandTheme: (theme: BrandTheme) => void;
}

export const BrandThemeContext = createContext<BrandThemeContextValue>({
  brandTheme: PLATFORM_DEFAULT_THEME,
  setBrandTheme: () => {},
});

export function useBrandTheme(): BrandThemeContextValue {
  return useContext(BrandThemeContext);
}
